"use strict";
/* globals module */
/**
 * @module calendarRsvpAttendeeBatchClient
 * @description  CalendarRsvpAttendeeBatchClient provides an easy way to consume CalendarRsvpAttendeeBatch REST API end-points. In order to obtain needed routes `calendarRsvpAttendeeBatchClient` uses `calendarRsvpAttendeeBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var httpApi_1 = require("../../../../httpApi");
var __1 = require("../../");
var CalendarRsvpAttendeeBatchClient = /** @class */ (function () {
    function CalendarRsvpAttendeeBatchClient(calendarRsvpAttendeeBatchRoute, apiClient) {
        this.calendarRsvpAttendeeBatchRoute = calendarRsvpAttendeeBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarRsvpAttendeeBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarRsvpAttendeeBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the link CalendarEvenAttendees action has been performed; this action links new CalendarEventAttendee resources to the calendarEvent.
     * @method
     * @param data CalendarEventAttendee objects that need to be inserted into the system.
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @returns A promise that is resolved once the link CalendarEventAttendees action has been performed.
     * @example calendarRsvpAttendeeBatchClient.link(calendarId, eventId, [{
                    AttendeeStatus: <calendar-evetn-attendee-status>,
                    AttendeeStatusId '<attendee-status-id>',
                    DateCreated: '<date-created>',
                    DateUpdated: '<date-updated>',
                    Email: '<email>',
                    EventID: '<calendar-event-id>',
                    FullName: '<full-name>',
                    Id: '<id>',
                    InvitationType: <calendar-event-invitation-type>,
                    InvitationTypeId: '<invitation-type-id>',
                    Json: '<json>',
                    Slots: <slots>,
                    SlotsRequested: <slots-requested>,
                    User: <user-profile>,
                    UserID: '<user-id>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeBatchClient.prototype.link = function (calendarId, eventId, data) {
        return this.apiClient.post(this.routeDefinition.link(calendarId, eventId), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventAttendees action has been performed; this action updates CalendarEventAttendee resources.
     * @method
     * @param data CalendarEventAttendee objects used to update specified CalendarEventAttendee resources.
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @returns A promise that is resolved once the update CalendarEventAttendees action has been performed.
     * @example calendarEventAttendees are resources previously fetched using get action.
                calendarRsvpAttendeeBatchClient.update(calendarId, eventId, calendarEventAttendees)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeBatchClient.prototype.update = function (calendarId, eventId, data) {
        return this.apiClient.put(this.routeDefinition.update(calendarId, eventId), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will unlink CalendarEventAttendee resources from the specified calendarEvent if successfully completed.
     * @method
     * @param data CalendarEventAttendee Ids which uniquely identify CalendarEventAttendee resources to be deleted.
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example calendarEventAttendeeIds are identifiers which uniquely identify CalendarEventAttendee resources.
                calendarRsvpAttendeeBatchClient.unlink(calendarId, eventId, calendarEventAttendeeIds)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeBatchClient.prototype.unlink = function (calendarId, eventId, data) {
        return this.apiClient.delete(this.routeDefinition.unlink(calendarId, eventId), undefined, this.routeDefinition.deleteParams(data));
    };
    var _a, _b;
    CalendarRsvpAttendeeBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarRsvpAttendeeBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarRsvpAttendeeBatchRoute !== "undefined" && __1.CalendarRsvpAttendeeBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CalendarRsvpAttendeeBatchClient);
    return CalendarRsvpAttendeeBatchClient;
}());
exports.CalendarRsvpAttendeeBatchClient = CalendarRsvpAttendeeBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 
